<p-toast></p-toast>
<p-confirmDialog [style]="{width: '50vw'}" [baseZIndex]="10000"></p-confirmDialog>

<div class="h-full center-container">
  <div class="grid w-full">
    <div class="card">
      <p-toolbar>
        <div class="p-toolbar-group-center w-full">
          <div class="field mb-0 col-12">
            <div class="col-12 flex align-content-left justify-content-start align-items-center">
              <h3 class="m-0">Lot Settings {{ locationId }}</h3>
            </div>
          </div>
        </div>
      </p-toolbar>

      <div class="col-12">

        <!-- Loading State -->
        <div *ngIf="checkingAccess" class="flex justify-content-center align-items-center" style="min-height: 300px;">
          <p-progressSpinner></p-progressSpinner>
        </div>

        <!-- Access Denied -->
        <div *ngIf="!checkingAccess && !hasAccess" class="flex justify-content-center align-items-center" style="min-height: 300px;">
          <p-message severity="error" text="You do not have access to this feature. Portal Developer role required."></p-message>
        </div>

        <!-- Main Content -->
        <div *ngIf="!checkingAccess && hasAccess">

          <!-- LPR Configuration Section -->
          <div class="mt-4">
            <p-panel header="LPR Configuration" [toggleable]="true">

              <!-- Role Access Info -->
              <div class="mb-3 p-3 bg-blue-50 border-round">
                <p class="m-0 text-sm">
                  <i class="pi pi-info-circle mr-2"></i>
                  <strong>Portal Developer</strong> access required
                </p>
              </div>

              <!-- Warning Message -->
              <div class="mb-4 p-3 bg-yellow-50 border-round border-left-3 border-yellow-500">
                <p class="m-0 text-sm">
                  <i class="pi pi-exclamation-triangle mr-2 text-yellow-700"></i>
                  <strong>Warning:</strong> Enabling/disabling the LPR setting (<code>cpp_multi_keycard_feature_enabled_{{ locationId }}</code>)
                  is not backwards compatible and should only be used for troubleshooting.
                </p>
              </div>

              <!-- LPR Enable/Disable Toggle -->
              <div class="field">
                <div class="flex align-items-center justify-content-between p-3 border-1 surface-border border-round">
                  <div class="flex-1">
                    <label for="lprEnabled" class="font-semibold">Enable Multi-Keycard LPR</label>
                    <p class="text-sm text-color-secondary m-0 mt-1">
                      Controls the <code>cpp_multi_keycard_feature_enabled_{{ locationId }}</code> variable
                    </p>
                  </div>
                  <div>
                    <p-inputSwitch
                      [(ngModel)]="lprEnabled"
                      (onChange)="onLprToggleChange($event)"
                      [disabled]="loadingLprStatus || updatingLprStatus"
                      inputId="lprEnabled">
                    </p-inputSwitch>
                  </div>
                </div>
              </div>

              <!-- Activate LPR Button -->
              <div class="field mt-4">
                <div class="p-3 border-1 surface-border border-round">
                  <h4 class="mt-0 mb-2">Activate LPR</h4>
                  <p class="text-sm text-color-secondary mt-0 mb-3">
                    Run the LPR activation process which:
                  </p>
                  <ul class="text-sm text-color-secondary mt-0 mb-3 pl-4">
                    <li>Sets the <code>cpp_multi_keycard_feature_enabled_{{ locationId }}</code> variable to TRUE</li>
                    <li>Clears the Drupal variable cache</li>
                    <li>Updates invoice records to version 3</li>
                  </ul>
                  <p-button
                    label="Activate LPR"
                    icon="pi pi-play"
                    (onClick)="activateLpr()"
                    [loading]="activatingLpr"
                    [disabled]="activatingLpr">
                  </p-button>
                </div>
              </div>

              <!-- Activation Output -->
              <div class="field mt-4" *ngIf="showActivationOutput">
                <p-panel header="Activation Output" [toggleable]="true" [collapsed]="false">
                  <ng-template pTemplate="icons">
                    <button
                      pButton
                      type="button"
                      icon="pi pi-times"
                      class="p-panel-header-icon p-link"
                      (click)="clearActivationOutput()"
                      pTooltip="Clear output">
                    </button>
                  </ng-template>

                  <div class="activation-output p-3 bg-gray-900 border-round" style="font-family: 'Courier New', monospace; color: #e0e0e0;">
                    <div *ngFor="let message of activationMessages" class="mb-1" [innerHTML]="message"></div>
                    <div *ngIf="activationMessages.length === 0" class="text-color-secondary">
                      <i>No output yet...</i>
                    </div>
                  </div>
                </p-panel>
              </div>

            </p-panel>
          </div>

        </div>

      </div>
    </div>
  </div>
</div>
